import React, { FC } from "react"
import { SEGMENT_COLORS } from "./distribution-utils"

export const DistributionBar: FC<{ names: string[]; percentages: number[] }> = ({
  names,
  percentages,
}) => (
  <div
    style={{
      display: "flex",
      width: "100%",
      height: 28,
      borderRadius: 4,
      overflow: "hidden",
      marginBottom: 4,
    }}
  >
    {percentages.map((pct, i) => (
      <div
        key={i}
        style={{
          width: `${pct}%`,
          background: SEGMENT_COLORS[i % SEGMENT_COLORS.length],
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontSize: 11,
          overflow: "hidden",
          whiteSpace: "nowrap",
          transition: "width 0.1s",
          padding: "0 4px",
        }}
      >
        {pct > 8 ? `${names[i] || `V${i + 1}`} · ${pct}%` : pct > 3 ? `${pct}%` : ""}
      </div>
    ))}
  </div>
)
